import Storage from './storageLib'
import store from '../store'
import {constantStrings} from './constants'
import I18n from './localization/i18n-setup'
import { getTranslation } from './utils'

export default {
    DEFAULT_CONFIG: {
        title: () => {},
        options: () => {},
        clickHandler: () => {}
    },
    LANGUAGE_CONFIG: {
        icon: 'GlobeIcon',
        title: () => `${getTranslation(constantStrings.LANGUAGE)} - ${I18n.locale?.toUpperCase()}`,
        options: () => store.state.widgetConfig?.multilingual?.languages,
        clickHandler: async ({code}) => {
            await Promise.all([I18n.loadBotConstantLocaleMessages(code), I18n.loadBotJsonConfigLocaleMessages(code)]) 
            Storage.setLocalStorageData(constantStrings.CURRENT_LOCALE, code)
            I18n.setI18nLanguage(code)
        },
        activeClassConditions: {
            enabled: true,
            condition: (item) => item.code === I18n.locale
        },
    }
}
